import { useNavigate } from 'react-router-dom'
import { EmployeeLogin } from 'modules/auth/components/EmployeeLogin'

export function EmployeeLoginPage() {
  const navigate = useNavigate()

  const handleLogin = (userData: any) => {
    navigate('/modules', { replace: true, state: { user: userData } })
  }

  const handleBack = () => {
    navigate('/login')
  }

  return <EmployeeLogin onLogin={handleLogin} onBack={handleBack} />
}
